import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import messages from '../../messages';
import commonMessages from '../../../messages';
import commonStyles from '../../../style.module.less';
import style from '../../style.module.less';

const SaveSetupStep = () => {
  return (
    <div className={commonStyles['step-content']}>
      <Text className={style['step-title']} textType={TextType.H3} value={messages.saveAutoRouting} />
      <Text className={style['step-paragraph']} textType={TextType.Paragraph} value={messages.setupAutoRoutingCompleteParagraph1} />
      <Text
        className={style['step-paragraph']}
        formattedMessageValues={{
          b: (chunks) => <span className={commonStyles.bolded}>{chunks}</span>,
        }}
        textType={TextType.Paragraph}
        value={messages.directionToCompleteAutoRoutingSetup}
      />
      <Text
        className={style['step-paragraph']}
        formattedMessageValues={{
          b: (chunks) => <span className={commonStyles.bolded}>{chunks}</span>,
        }}
        textType={TextType.Paragraph}
        value={messages.whatHappenAfterAutoRoutingSetupComplete}
      />
      <Text textType={TextType.H4} value={commonMessages.routingType} />
      <Text textType={TextType.Paragraph} value={commonMessages.routingTypeActiveShippingLocations} />
    </div>
  );
};

export default SaveSetupStep;
